import type { RecurrenceRule } from '../../db/models'
import { parseRecurrencePhrase } from '../../recurrence/phrase'

/**
 * **Todoists Wiederholungs-Sätze → `RecurrenceRule`** (T10, #175).
 *
 * Todoist speichert eine Wiederholung als Satz („every 2 weeks on mon“, „alle! 3 Tage“), HappyTask als
 * Regel (ADR 0021). Gelesen wird der Satz von `parseRecurrencePhrase` (`lib/recurrence/phrase.ts`, seit
 * #234 auch für die Erkennung im Titel); hier kommt nur der Anker dazu: Nennt der Satz keinen Tag, kommt
 * er aus `due.date`. Was nicht übersetzbar ist, gibt `null` — die Aufgabe kommt dann einmalig an, mit dem
 * Satz in der Beschreibung (Konzept).
 */
export interface TodoistDue {
  date: string
  string?: string | null
  is_recurring: boolean
}

/** Todoists Startdatum als Kalendertag („2026-10-01“, auch mit Uhrzeit). */
function startOf(date: string): Date | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(date)
  return match ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])) : null
}

export function translateRecurrence(due: TodoistDue | null | undefined): RecurrenceRule | null {
  if (!due?.is_recurring || !due.string) return null
  return parseRecurrencePhrase(due.string, startOf(due.date))
}
